import { Skeleton } from "@codat/orchard-ui";
import React, { lazy } from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";

const RemoteActiveCompaniesChart = lazy(
  () => import("codat-products-ui/HomepageActiveCompaniesChart")
);

const ActiveCompaniesChart = () => (
  <React.Suspense fallback={<Skeleton height="15.5rem" width="100%" />}>
    <ErrorBoundary>
      <RemoteActiveCompaniesChart />
    </ErrorBoundary>
  </React.Suspense>
);

export default ActiveCompaniesChart;
